import React from "react";

// Official Adarsh Udyog logo (AJ + Adarsh Udyog + tagline).
export const ADARSH_LOGO_URL =
  "https://customer-assets.emergentagent.com/job_shelf-design-hub/artifacts/z7cw1kfs_Screenshot%202025-08-11%20at%201.08.54%20PM.png";

// Brand colour palette pulled directly from the logo.
export const BRAND = {
  red:   "#e04a2f", // "Adarsh"
  green: "#4a9b3f", // "Udyog"
  cream: "#f7f4ee",
  stone: "#efeae0",
};

/**
 * Small horizontal logo lockup used in every workspace header. Renders the
 * PNG on a light chip so it stays legible on both light and dark app themes.
 *
 * Props:
 *   size — pixel height of the logo image (defaults 22)
 *   showChip — wrap the logo in a white rounded chip (defaults true)
 */
export function BrandLogo({ size = 22, showChip = true, className = "" }) {
  const img = (
    <img
      src={ADARSH_LOGO_URL}
      alt="Adarsh Udyog — A Complete Storage Solution"
      style={{ height: size, width: "auto" }}
      className="block select-none"
      draggable={false}
    />
  );
  if (!showChip) return <div className={className}>{img}</div>;
  return (
    <div
      className={`inline-flex items-center gap-2 rounded-sm bg-white/95 border border-neutral-200/70 px-2 py-1 shadow-sm ${className}`}
    >
      <span className="w-1 h-4 rounded-sm shrink-0" style={{ background: BRAND.red }} />
      <span className="w-1 h-4 rounded-sm shrink-0" style={{ background: BRAND.green }} />
      {img}
    </div>
  );
}
